export class User {
    id: number;
    prenom: string;
    nom: string;
    email: string;
    telephone: string;
    login: string;
    password: string;
    idprofil: number;
    idfonction: number;
    iddirection: number;
    idpole: number;
    societe: number;
    idsuperieur: number;
    admin: boolean;
    statut: boolean;
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/models/user.ts